import { create } from 'zustand'

// Define the store's state
type MeetTheCastState = {
  badge: string
  duration: number
  setBadgeUrl: (value: string) => void
}

// Create the store
export const useMeetTheCastStore = create<MeetTheCastState>((set) => ({
  badge: '',
  duration: 3500,
  setBadgeUrl: (value) => set({ badge: value }),
}))
